<section class="offline-picker" data-cy="offline-picker">
  <button
    type="button"
    class="offline-picker__close"
    aria-label="Fechar"
    data-cy="offline-picker-close"
    (click)="onCancel()">
    <i class="uil uil-times" aria-hidden="true"></i>
  </button>

  <header class="offline-picker__header">
    <span class="offline-picker__icon" aria-hidden="true">
      <i class="uil uil-wifi"></i>
    </span>
    <div class="offline-picker__heading">
      <span class="offline-picker__eyebrow">Modo Offline</span>
      <h2 class="offline-picker__title">Qual atribuição vai ficar ativa offline?</h2>
    </div>
  </header>
  <p class="offline-picker__lead">
    As outras continuam na lista, mas sem ação, até você desligar o modo.
  </p>

  <div class="offline-picker__body" role="radiogroup" aria-label="Atribuições disponíveis">
    @if (isLoading()) {
      <p class="offline-picker__status" data-cy="offline-picker-loading">
        Carregando suas atribuições…
      </p>
    } @else if (hasError()) {
      <div class="offline-picker__empty" data-cy="offline-picker-error">
        <p class="offline-picker__empty-title">Não foi possível carregar suas atribuições</p>
        <p class="offline-picker__empty-text">
          O Modo Offline precisa de internet para ser ligado. Verifique a conexão e tente de novo.
        </p>
        <button
          type="button"
          class="offline-picker__link"
          data-cy="offline-picker-retry"
          (click)="load()">
          Tentar de novo
        </button>
      </div>
    } @else if (isEmpty()) {
      <div class="offline-picker__empty" data-cy="offline-picker-empty">
        <p class="offline-picker__empty-title">Você ainda não tem atribuições</p>
        <p class="offline-picker__empty-text">
          O Modo Offline leva uma atribuição para a sala de aula. Quando alguma trilha ou aula for
          atribuída a você, ela aparece aqui para ser escolhida.
        </p>
      </div>
    } @else {
      <ol class="offline-picker__list">
        @for (option of options(); track option.selection.idAssignment) {
          <li class="offline-picker__item">
            <label
              class="offline-picker__option"
              [class.offline-picker__option--selected]="
                selectedId() === option.selection.idAssignment
              "
              [attr.data-cy]="'offline-picker-item-' + option.selection.idAssignment">
              <input
                class="offline-picker__radio"
                type="radio"
                name="offline-assignment"
                [value]="option.selection.idAssignment"
                [checked]="selectedId() === option.selection.idAssignment"
                (change)="onSelect(option)"
                [attr.aria-label]="'Escolher ' + option.vm.content.title"
                [attr.data-cy]="'offline-picker-radio-' + option.selection.idAssignment" />
              <app-assignment-card
                [assignment]="option.vm"
                offlineState="context"
                [showActions]="false"
                [selected]="selectedId() === option.selection.idAssignment" />
            </label>
          </li>
        }
      </ol>
    }
  </div>

  <footer class="offline-picker__footer">
    <button
      type="button"
      class="offline-picker__button offline-picker__button--ghost"
      data-cy="offline-picker-cancel"
      (click)="onCancel()">
      Cancelar
    </button>
    <button
      type="button"
      class="offline-picker__button offline-picker__button--primary"
      data-cy="offline-picker-confirm"
      [disabled]="!selected()"
      (click)="onConfirm()">
      Carregar atribuição
    </button>
  </footer>
</section>
